module.exports = __webpack_public_path__ + "static/media/United_States_Department_of_Agriculture.398c92b9.svg";